(() => {
  'use strict';

  const root = document.querySelector('[data-kc-root]');
  if (!root || root.dataset.kcReady === 'true') return;
  root.dataset.kcReady = 'true';

  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
  const endpoint = root.dataset.endpoint || '';
  const form = $('[data-kc-form]');
  const input = $('[data-kc-input]');
  const send = $('[data-kc-send]');
  const messages = $('[data-kc-messages]');
  const mode = $('[data-kc-mode]');
  const stageBadge = $('[data-kc-stage]');
  const knownList = $('[data-kc-known]');
  const unknownList = $('[data-kc-unknown]');
  const recList = $('[data-kc-recommendations]');
  const recCount = $('[data-kc-rec-count]');
  const nextMove = $('[data-kc-next]');
  const nextWrap = $('[data-kc-next-wrap]');
  const contactButton = $('[data-kc-open-contact]');
  const contactSection = $('[data-kc-contact-section]');
  const contactFrame = $('[data-kc-contact-frame]');
  const honeypot = $('[data-kc-honeypot]');
  const reset = $('[data-kc-reset]');
  const catalog = new Map();
  let history = [];
  let currentFrame = null;
  let busy = false;

  $$('[data-kc-product]').forEach((node) => {
    const id = node.dataset.id;
    if (!id) return;
    catalog.set(id, {
      id,
      title: node.dataset.title || id,
      url: node.dataset.url || '/pages/library',
      price: node.dataset.price || '',
      image: node.dataset.image || '',
      age: node.dataset.age || '',
      format: node.dataset.format || '',
      summary: node.dataset.summary || '',
      available: node.dataset.available !== 'false'
    });
  });

  const visitorId = (() => {
    const key = 'kala-concierge-visitor-v1';
    try {
      let value = sessionStorage.getItem(key);
      if (!value) {
        value = crypto.randomUUID ? crypto.randomUUID() : `kc-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem(key, value);
      }
      return value;
    } catch (_) {
      return `kc-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    }
  })();

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function setMode(label, kind = '', title = '') {
    if (!mode) return;
    mode.textContent = label;
    mode.classList.remove('is-ai', 'is-guided', 'is-working');
    if (kind) mode.classList.add(`is-${kind}`);
    mode.title = title;
  }

  function setBusy(value) {
    busy = value;
    root.classList.toggle('is-busy', value);
    if (send) {
      send.disabled = value;
      const label = send.querySelector('span');
      if (label) label.textContent = value ? 'Building the frame\u2026' : 'Build my decision frame';
    }
    if (input) input.disabled = value;
    if (value) setMode('Thinking with Kala', 'working', 'The live exchange is being processed server-side.');
  }

  function addMessage(role, text, meta = '') {
    if (!messages || !text) return;
    const article = el('article', `kc-message kc-message-${role}`);
    const mark = el('div', 'kc-message-mark', role === 'assistant' ? 'K' : 'YOU');
    mark.setAttribute('aria-hidden', 'true');
    const body = el('div', 'kc-message-body');
    String(text).split(/\n\n+/).filter(Boolean).forEach((part) => body.appendChild(el('p', '', part)));
    if (meta) body.appendChild(el('span', 'kc-message-meta', meta));
    article.append(mark, body);
    messages.appendChild(article);
    messages.scrollTop = messages.scrollHeight;
  }

  function setField(name, value, fallback) {
    const node = $(`[data-kc-field="${name}"]`);
    if (!node) return;
    node.textContent = Array.isArray(value) ? (value.length ? value.join(' \u00b7 ') : fallback) : (value || fallback);
  }

  function renderList(node, items, fallback) {
    if (!node) return;
    node.textContent = '';
    const values = Array.isArray(items) ? items.filter(Boolean).slice(0, 8) : [];
    (values.length ? values : [fallback]).forEach((value) => node.appendChild(el('li', '', value)));
  }

  const stageLabels = { understand: 'Understand', narrow: 'Narrow', compare: 'Compare', ready: 'Ready to choose' };

  function recCard(rec, index) {
    const product = catalog.get(rec.id);
    const card = el('article', 'kc-rec-card');
    const media = el('div', 'kc-rec-media');
    media.appendChild(el('span', 'kc-rec-rank', String(index + 1).padStart(2, '0')));
    if (product?.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    } else {
      media.appendChild(el('span', '', 'K'));
    }

    const copy = el('div', 'kc-rec-copy');
    const meta = [product?.age, product?.format, product?.price].filter(Boolean).join(' \u00b7 ') || 'Kala starting point';
    copy.appendChild(el('p', 'kc-rec-meta', meta));
    copy.appendChild(el('h4', '', product?.title || 'Kala recommended starting point'));
    copy.appendChild(el('p', 'kc-rec-fit', rec.fit || product?.summary || 'A focused starting point from the current Kala catalog.'));
    const first = el('p', 'kc-rec-first');
    first.append(el('b', '', 'Use first: '), document.createTextNode(rec.use_first || 'Review the preview and begin with the smallest useful section.'));
    copy.appendChild(first);
    const link = el('a', 'kc-rec-link', product?.available === false ? 'Review this item' : 'View this item');
    link.href = product?.url || '/pages/library';
    copy.appendChild(link);
    card.append(media, copy);
    return card;
  }

  function renderRecommendations(recommendations) {
    if (!recList) return;
    const items = Array.isArray(recommendations) ? recommendations.slice(0, 3) : [];
    recList.textContent = '';
    if (!items.length) {
      const empty = el('div', 'kc-empty-state');
      empty.append(el('span', '', '\u2726'), el('p', '', 'Kala needs one more decision detail before selecting a starting point.'));
      recList.appendChild(empty);
    } else {
      items.forEach((rec, index) => recList.appendChild(recCard(rec, index)));
    }
    if (recCount) recCount.textContent = `${items.length} selected`;
  }

  function contactSummary(frame) {
    if (!frame) return '';
    const intake = frame.intake || {};
    const recs = (frame.recommendations || []).map((rec, index) => {
      const product = catalog.get(rec.id);
      return `${index + 1}. ${product?.title || rec.id}: ${rec.fit || ''}`;
    });
    return [
      'ASK KALA \u00b7 DECISION FRAME',
      '',
      `Stage: ${stageLabels[frame.stage] || 'Understand'}`,
      `Audience: ${intake.audience || 'Not established'}`,
      `Age or stage: ${intake.child_age || 'Not established'}`,
      `Primary goal: ${intake.primary_goal || 'Not established'}`,
      `Secondary goal: ${intake.secondary_goal || 'Not established'}`,
      `Preferred format: ${intake.format_preference || 'Open'}`,
      `Setting: ${intake.setting || 'Not established'}`,
      `Constraints: ${(intake.constraints || []).join('; ') || 'None stated'}`,
      '',
      'KNOWN',
      ...(intake.known || []).map((item) => `\u2022 ${item}`),
      '',
      'STILL UNKNOWN',
      ...(intake.unknown || []).map((item) => `\u2022 ${item}`),
      '',
      'STARTING POINTS',
      ...(recs.length ? recs : ['No product recommendation yet.']),
      '',
      `Next move: ${frame.next_question || 'Human review requested.'}`,
      frame.contact_reason ? `Handoff reason: ${frame.contact_reason}` : '',
      frame.safety_note ? `Important: ${frame.safety_note}` : ''
    ].filter((line) => line !== '').join('\n');
  }

  function renderFrame(frame) {
    currentFrame = frame;
    const intake = frame?.intake || {};
    if (stageBadge) stageBadge.textContent = stageLabels[frame?.stage] || 'Understand';
    setField('audience', intake.audience, 'Not established');
    setField('child_age', intake.child_age, 'Not established');
    setField('primary_goal', intake.primary_goal, 'Not established');
    setField('format_preference', intake.format_preference, 'Open');
    setField('setting', intake.setting, 'Not established');
    setField('constraints', intake.constraints, 'None stated');
    renderList(knownList, intake.known, 'No decision details have been confirmed yet.');
    renderList(unknownList, intake.unknown, 'No material unknowns remain.');
    renderRecommendations(frame?.recommendations);

    const next = frame?.safety_note || frame?.next_question || 'Review the first recommendation and confirm whether its format fits your routine.';
    if (nextMove) nextMove.textContent = next;
    if (nextWrap) nextWrap.classList.toggle('is-safety', Boolean(frame?.safety_note));
    if (contactButton) {
      contactButton.classList.toggle('is-recommended', Boolean(frame?.contact_recommended));
      const label = contactButton.querySelector('span');
      if (label) label.textContent = frame?.contact_recommended ? 'Continue with a human concierge' : 'Send this frame to Kala';
    }
    if (contactFrame) contactFrame.value = contactSummary(frame);
  }

  function localFallback(text) {
    const lower = text.toLowerCase();
    let goal = 'Choosing a useful Kala starting point';
    let id = 'first_words_core';
    let fit = 'A clear, calm first look at the current Kala library.';
    let safety = null;
    if (/sleep|bedtime|nap/.test(lower)) { goal = 'A calmer family sleep routine'; id = 'sleep_bundle'; fit = 'A parent-facing framework for organizing sleep routines and questions.'; safety = 'Sleep materials are educational support, not medical or sleep-safety advice.'; }
    else if (/tantrum|emotion|feeling|behavior/.test(lower)) { goal = 'Emotion language and calmer routines'; id = 'big_feelings'; fit = 'A focused bundle for emotion language, preparation, and repeatable routines.'; }
    else if (/talk|speech|word|vocab|language/.test(lower)) { goal = 'Early words and shared language moments'; id = 'first_words_core'; fit = 'A real-photo first-word book designed for calm naming and shared attention.'; }
    else if (/curriculum|preschool|homeschool|lesson/.test(lower)) { goal = 'A structured preschool learning path'; id = 'early_scholars'; fit = 'A coherent 36-week digital curriculum rather than a single activity.'; }
    else if (/school|library|bulk|license|educator|institution|partnership/.test(lower)) { goal = 'Institutional use or partnership'; id = 'early_scholars'; fit = 'A useful reference point before a human review of licensing, quantities, and context.'; }
    const ageMatch = text.match(/\b(\d{1,2})\s*(month|months|mo|year|years|yr|yrs)\b/i);
    const age = ageMatch ? `${ageMatch[1]} ${ageMatch[2]}` : (/toddler/i.test(text) ? 'Toddler' : /preschool/i.test(text) ? 'Preschool' : null);
    const contact = /school|library|bulk|license|educator|institution|partnership/.test(lower);
    return {
      assistant_message: `I organized this as a ${goal.toLowerCase()} decision. This guided frame is a practical starting point, not an assessment of a child.`,
      stage: age ? 'narrow' : 'understand',
      intake: {
        audience: contact ? 'Educator or institution' : 'Parent or caregiver',
        child_age: age,
        primary_goal: goal,
        secondary_goal: null,
        format_preference: /digital|download|printable/.test(lower) ? 'Digital' : /physical|paper book|hardcopy/.test(lower) ? 'Physical' : null,
        setting: /school|classroom/.test(lower) ? 'School or classroom' : /library/.test(lower) ? 'Library' : /home/.test(lower) ? 'Home' : null,
        constraints: [],
        known: [age ? `Broad age or stage: ${age}` : 'No broad age or stage confirmed yet', `Current goal: ${goal}`],
        unknown: [!age ? 'Broad age or stage' : null, 'Preferred format', 'Where the resource will be used'].filter(Boolean)
      },
      recommendations: [{ id, fit, use_first: 'Open the product page, review the preview, and begin with the smallest useful section.', priority: 1 }],
      next_question: age ? 'Do you prefer a physical book, a digital guide, or a structured curriculum?' : 'What broad age or stage are you choosing for?',
      contact_recommended: contact,
      contact_reason: contact ? 'Licensing, bulk quantities, educator use, and partnerships need a human review.' : null,
      safety_note: safety
    };
  }

  async function exchange(userText) {
    setBusy(true);
    addMessage('user', userText, 'Your input');
    history.push({ role: 'user', content: userText });
    history = history.slice(-12);

    try {
      if (!endpoint) throw new Error('missing_endpoint');
      const response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ visitor_id: visitorId, messages: history, website: honeypot?.value || '' })
      });
      const payload = await response.json().catch(() => ({}));
      if (!payload.frame) throw new Error(payload.error || 'no_frame');
      const frame = payload.frame;
      const reply = `${frame.assistant_message || 'I organized the decision frame.'}${frame.next_question ? `\n\n${frame.next_question}` : ''}`;
      const live = payload.mode === 'ai';
      addMessage('assistant', reply, live ? 'AI-assisted intake \u00b7 Claude' : 'Guided catalog intake');
      history.push({ role: 'assistant', content: reply });
      history = history.slice(-12);
      renderFrame(frame);
      setMode(live ? 'AI live \u00b7 Claude' : 'Guided intake', live ? 'ai' : 'guided', live ? 'This exchange used Kala\u2019s server-side project AI capacity.' : (payload.message || payload.disclosure || 'Structured catalog guidance is active.'));
    } catch (_) {
      const frame = localFallback(userText);
      const reply = `${frame.assistant_message}\n\n${frame.next_question || ''}`.trim();
      addMessage('assistant', reply, 'Guided intake \u00b7 live AI unavailable');
      history.push({ role: 'assistant', content: reply });
      renderFrame(frame);
      setMode('Guided intake', 'guided', 'The live server-side AI path could not be reached, so the local catalog guide was used.');
    } finally {
      setBusy(false);
      input?.focus({ preventScroll: true });
    }
  }

  function resetWorkspace() {
    history = [];
    currentFrame = null;
    if (messages) {
      messages.textContent = '';
      addMessage('assistant', 'I\u2019ll help you narrow Kala\u2019s current library without creating a child profile. Share a broad age or stage, the goal, and whether this is for home, school, a library, or another setting.', 'Decision intake');
    }
    renderFrame({
      stage: 'understand',
      intake: { audience: null, child_age: null, primary_goal: null, format_preference: null, setting: null, constraints: [], known: [], unknown: ['Broad age or stage', 'Primary goal', 'Preferred format'] },
      recommendations: [],
      next_question: 'Start with one broad age or stage and one outcome you hope to support.',
      contact_recommended: false,
      contact_reason: null,
      safety_note: null
    });
    if (contactFrame) contactFrame.value = '';
    setMode('Intake ready');
    if (input) { input.value = ''; input.style.height = ''; input.focus(); }
  }

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (busy || !input) return;
    const value = input.value.replace(/\s+/g, ' ').trim().slice(0, 800);
    if (!value) { input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
    input.removeAttribute('aria-invalid');
    input.value = '';
    input.style.height = '';
    exchange(value);
  });

  input?.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = `${Math.min(input.scrollHeight, 190)}px`;
    input.removeAttribute('aria-invalid');
  });

  input?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      form?.requestSubmit();
    }
  });

  $$('[data-kc-starter]').forEach((button) => button.addEventListener('click', () => {
    if (busy || !input) return;
    input.value = button.dataset.kcStarter || '';
    input.dispatchEvent(new Event('input'));
    form?.requestSubmit();
  }));

  reset?.addEventListener('click', resetWorkspace);

  contactButton?.addEventListener('click', () => {
    if (contactFrame && currentFrame) contactFrame.value = contactSummary(currentFrame);
    contactSection?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    const first = contactSection?.querySelector('input:not([type="hidden"])');
    setTimeout(() => first?.focus({ preventScroll: true }), 450);
  });
})();
